<template>
  <div>
    <LessonProductModal
      v-if="isOpen"
      :isOpen="isOpen"
      :reload="reload"
      :close="modalClose"
      :selected="selected"
    />
    <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
      <b-row class="my-4 min-width-full align-items-center">
        <b-col md="4">
          <b-input-group>
            <b-form-input
              id="inline-form-input-name"
              class=" mr-sm-2 md-4"
              placeholder="상품명을 입력하세요."
              v-model="search.title"
              v-on:keyup.enter="handleSearch"
            ></b-form-input>
            <b-input-group-append>
              <Button :type="ButtonTypes.blue" label="검색" :on-click="handleSearch"/>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="3">
          <b-form-checkbox
            v-model="search.checkDeleted"
            v-on:click="handleChangeCheckbox()"
            class="mt-sm"
          >
            삭제 포함
          </b-form-checkbox>
        </b-col>
        <b-col class="text-right">
          <Button :type="ButtonTypes.purple" label="등록" :on-click="modalClose"/>
        </b-col>
      </b-row>
      <b-table :fields="fields" :items="products" class="text-left">
        <template #cell(title)="data">
          <Badge
            :type="data.item.status === 'PUBLISHED' ? BadgeTypes.green : BadgeTypes.red"
            :label="data.item.status"
          />
          {{data.item.title}}
        </template>
        <template #cell(amount)="data">
          {{ `${data.item.amount.toLocaleString()}원`}}
        </template>
        <template #cell(monthlyLimitCount)="data">
          <Badge
            v-if="data.item.setMonthlyLimitCount"
            :type="data.item.setMonthlyLimitCount ? BadgeTypes.green : BadgeTypes.red"
            label="제한"
          />
          {{data.item.setMonthlyLimitCount ? `${data.item.monthlyLimitCount}개` : ""}}
        </template>
        <template #cell(createdAt)="data">
          {{ getDate(data.item.createdAt)}}
        </template>
        <template #cell(button)="data">
          <div class="inline-flex justify-end items-center gap-2 text-right w-full">
            <Button v-if="data.item.deletedAt === null" :type="ButtonTypes.blue" label="상세" :onClick="() => setDetail(data.item)" />
            <Button v-if="data.item.deletedAt === null" :type="ButtonTypes.red" label="삭제" :onClick="() => setDelete(data.item)" />
            <span v-if="data.item.deletedAt !== null">{{getDate(data.item.deletedAt)}} 삭제</span>
          </div>
        </template>
      </b-table>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        @page-click="changePage"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import customDate from "@/util/custom-date";
import LessonProductModal from "@/components/modals/LessonProductModal.vue"
import {BadgeTypes, ButtonTypes} from "@/util/enums";
import Badge from "@/components/Badge.vue";
import Button from "@/components/Button.vue";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    BadgeTypes() {
      return BadgeTypes
    },
  },
  components: {LessonProductModal, Badge, Button},
  data() {
    return {
      products: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      isOpen: false,
      selected: null,
      fields: [
        {
          label: '상품명',
          key: 'title',
        },
        {
          label: '가격',
          key: 'amount',
        },
        {
          label: '월별 판매 제한',
          key: 'monthlyLimitCount',
        },
        {
          label: '생성일',
          key: 'createdAt',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      search: {
        title: "",
        checkDeleted: false
      },
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.title = query.keyword
    }
    if (query.checkDeleted === 'true') {
      this.search.checkDeleted = true
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    modalClose(){
      this.selected = null
      this.isOpen = !this.isOpen
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleChangeCheckbox() {
      this.search.checkDeleted = !this.search.checkDeleted
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      if (this.search.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.replace({ query })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    setDetail(selected) {
      this.selected = selected
      this.isOpen = !this.isOpen
    },
    setDelete(product){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '결제 상품 삭제',
        html: `${product.title}을 삭제합니다.`,
        confirm: () => {
          api.productLesson.delete(product.id , () => {
            this.getPagingList(this.currentPage)
          },(err) => {
            console.log(err)
          })
        }
      });
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.title,
        showDeleted: this.search.checkDeleted
      }
      
      api.productLesson.search(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.products = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>